import { Theme, createTheme } from '@mui/material/styles';

const theme = (mainTheme: Theme) =>
  createTheme({
    ...mainTheme,
    direction: 'rtl',
  });

export default theme;
